import { api } from '@services';

interface IRequest {
  id: string | undefined;
  clone: {
    status: boolean;
    assignee: boolean;
    tags: boolean;
    photos: boolean;
    internalData: boolean;
  };
  serial: string;
  customFields?: Array<{
    id: string;
    value: string;
  }>;
}

interface IResponse {
  id: string;
  message: string;
}

const cloneAssets = async ({ id, ...data }: IRequest): Promise<IResponse> => {
  const { data: responseData } = await api.post(
    `/equipments/${id}/clone`,
    data,
  );
  return responseData;
};

export { cloneAssets };
